/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteMemoryStoreRequest = {
  memoryStoreId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteMemoryStoreRequest$inboundSchema: z.ZodType<
  DeleteMemoryStoreRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  memory_store_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "memory_store_id": "memoryStoreId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteMemoryStoreRequest$Outbound = {
  memory_store_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteMemoryStoreRequest$outboundSchema: z.ZodType<
  DeleteMemoryStoreRequest$Outbound,
  z.ZodTypeDef,
  DeleteMemoryStoreRequest
> = z.object({
  memoryStoreId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    memoryStoreId: "memory_store_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteMemoryStoreRequestToJSON(
  deleteMemoryStoreRequest: DeleteMemoryStoreRequest,
): string {
  return JSON.stringify(
    DeleteMemoryStoreRequest$outboundSchema.parse(deleteMemoryStoreRequest),
  );
}
export function deleteMemoryStoreRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteMemoryStoreRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteMemoryStoreRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteMemoryStoreRequest' from JSON`,
  );
}
